export default __webpack_public_path__ + "static/tabs-independent-do-1890b67a442e7ab8ff8c355260330685.png";